import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

export class HttpService {
  post<T, P>(
    url: string,
    payload: P,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return axios.post<P, AxiosResponse<T>>(url, payload, {
      ...config,
      maxRedirects: 0,
    })
  }

  patch<T, P>(
    url: string,
    payload: P,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return axios.patch<P, AxiosResponse<T>>(url, payload, {
      ...config,
      maxRedirects: 0,
    })
  }

  put<T, P>(
    url: string,
    payload: P,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return axios.put<P, AxiosResponse<T>>(url, payload, {
      ...config,
      maxRedirects: 0,
    })
  }

  get<T, P>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return axios.get<P, AxiosResponse<T>>(url, { ...config, maxRedirects: 0 })
  }

  delete<T, P>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return axios.delete<P, AxiosResponse<T>>(url, {
      ...config,
      maxRedirects: 0,
    })
  }
}
